import styled from "styled-components";

export const CustomButtonSearch = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding-bottom: 20px;
  padding-top: 10px;
  background-color: #e4e4e4;
`;

export const MainComSearch = styled.div<{isMobileScreen: boolean}>`
  background: #e4e4e4;
  padding-top: ${({isMobileScreen}) => (isMobileScreen ? `133px` : `10px`)};
  ${({ isMobileScreen }) =>
        isMobileScreen && 'min-height: calc(100dvh - 69px);'}
`;

export const Container = styled.div`
  display: flex;
  align-items: start;
  padding: 10px 20px 15px 20px;
  gap: 10px;
  flex-wrap: wrap;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-basis: 106px;
`;

export const Logo = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  border: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const Right = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-basis: calc(100% - 120px);
  margin: auto 0;
`;

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  h2 {
    font-weight: 700;
    text-decoration: underline;
    &:hover {
      cursor: pointer;
    }
  }
  p {
    font-size: 0.6875rem;
  }
`;

export const GroupService = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`;

export const Service = styled.div`
  border-radius: 15px;
  color: #2c76aa;
  text-decoration: underline;
  margin-right: 10px;
  font-size: 0.6875rem;
  &:hover {
    cursor: pointer;
  }
`;

export const ServicesMobile = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;
